export const LOCAL_STORAGE_KEY_LINK_TO_CAMPAIGN_SCRIPT_GENERATOR = "LINK_TO_CAMPAIGN_SCRIPT_GENERATOR";
export const LOCAL_STORAGE_KEY_COLLECTION_DATA = "COLLECTION_DATA";